export const PRODUCTION: string = 'production';

export const SET_LANGUAGE: string = 'SET_LANGUAGE';
export const STORE_ERROR: string = 'STORE_ERROR';
export const CLOSE_ERROR: string = 'CLOSE_ERROR';
export const SHOW_SUCCESS: string = 'SHOW_SUCCESS';

export const APP_DATA: string = 'APP_DATA';
export const HOME_DATA: string = 'HOME_DATA';
export const PERIOD_DATA: string = 'PERIOD_DATA';
export const ALL_ALBUM_DATA: string = 'ALL_ALBUM_DATA';
export const SEARCH_DATA: string = 'SEARCH_DATA';
export const MAP_DATA: string = 'MAP_DATA';
export const ADD_DATA: string = 'ADD_DATA';

export const MAX_WIDTH: number = 1024;
